export default __webpack_public_path__ + "static/char-s-sp03-zh-Hans-adf51b648695c04c52cee9477ad268a4.png";